import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const ProductCard = ({ product }) => {
  const getDifficultyColor = (diff) => {
    switch (diff) {
      case 'Easy': return 'bg-botanical text-white';
      case 'Medium': return 'bg-clay text-white';
      case 'Hard': return 'bg-botanical-dark text-white';
      default: return 'bg-gray-200 text-gray-800';
    }
  };

  return (
    <motion.div 
      whileHover={{ y: -5 }}
      className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all group flex flex-col h-full"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-cream-dark">
        <Link to={`/product/${product.id}`}>
          <img 
            src={product.image} 
            alt={product.name} 
            className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
          />
        </Link>
        {product.difficulty !== 'N/A' && (
          <div className="absolute top-4 left-4 flex flex-col gap-2">
            <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${getDifficultyColor(product.difficulty)}`}>
              {product.difficulty} Care
            </span>
          </div>
        )}
        <button className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm p-3 rounded-full text-botanical hover:bg-clay hover:text-white transition-colors shadow-sm opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 duration-300">
          <SafeIcon icon={FiIcons.FiPlus} className="text-xl" />
        </button>
      </div>

      <div className="p-5 flex flex-col flex-grow">
        <div className="flex justify-between items-start mb-2">
          <Link to={`/product/${product.id}`}>
            <h3 className="font-serif text-lg font-medium text-botanical-dark hover:text-clay transition-colors line-clamp-1">
              {product.name}
            </h3>
          </Link>
          <span className="font-medium text-botanical">${product.price}</span>
        </div>
        
        <div className="flex items-center gap-1 mb-3 text-clay-light text-sm">
          <SafeIcon icon={FiIcons.FiStar} className="fill-current" />
          <span>{product.rating}</span>
          <span className="text-gray-400">({product.reviews})</span>
        </div>

        <div className="mt-auto pt-4 border-t border-cream-dark flex items-center gap-2 text-sm text-gray-600">
          {product.lightLevel !== 'N/A' ? (
            <>
              <SafeIcon icon={FiIcons.FiSun} className="text-clay" />
              <span>{product.lightLevel} Light</span>
            </>
          ) : (
            <span className="text-gray-400 italic">Accessory</span>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;